/* eslint no-magic-numbers: 0 */

export const enum LabelSize {
  SMALL = 150,
  MEDIUM = 170,
  MEDIUM_LARGE = 210,
  LARGE = 250,
  LONG = 300,
  EXTRA_LONG = 350
}
